import React, { memo, useEffect } from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'

import Place from '../../../../components/Space/Place'
import Empty from '../../../../components/Space/Empty'
import Settings from './Settings'
import SlideMenu from '../../../../components/SlideMenu'
import { createSelector } from 'reselect'

// Мемоизированные компоненты
const MemoizedEmpty = memo(() => <Empty />)


// Основной компонент
const When = ({ showSettings }) => {


    return (
        <Place
            number={3}
            className="AdvertWhen"
        >
            {showSettings
                ? <SlideMenu
                    activeItem={1}
                    items={[
                        {
                            title: "Настройка ролика",
                            content: <Settings placeNumber={3} active />
                        }
                    ]}
                />
                : <MemoizedEmpty />

            }
        </Place>
    )

}

// Селекторы
const selectSelectedTracks = state => state.tracks.selected
const selectSelectedObjects = state => state.objects.selected
const selectDisableWhereAndWhenBlock = state => state.advert_page.disableWhereAndWhenBlock

const selectThemeIds = state => state.tracks.tracksTheme.map(tr => tr.id)
const selectSelectedThemeTracks = (state) => {
    const selected = selectSelectedTracks(state)
    const themesIds = selectThemeIds(state)
    return selected.filter(id => themesIds.includes(id))
}

// Главный селектор, вычисляющий все необходимые данные
const selectShouldShowSettings = createSelector(
    [selectSelectedTracks, selectSelectedObjects, selectSelectedThemeTracks, selectDisableWhereAndWhenBlock],
    (selectedTracks, selectedObjects, selectedThemeTracks, disableBlock) => ({
        showSettings: Boolean(
            selectedTracks?.length &&
            selectedObjects?.length &&
            !(selectedThemeTracks?.length && disableBlock)
        )
    })
)

// Сравнение пропсов
const areEqual = (prevProps, nextProps) => (
    prevProps.showSettings === nextProps.showSettings 
)

// Подключение к Redux с мемоизацией
const OptimizedWhen = memo(
    connect(
        state => selectShouldShowSettings(state),
        null
    )(When),
    areEqual
)

export default OptimizedWhen